import React from 'react';
import {useRouter} from 'next/router';
import Link from 'next/link';
import Container from '@/components/atoms/Container';
import Icon from '@/components/atoms/Icon';
import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = () => {
    const router = useRouter();
    const pathSegments = router.asPath
        .split('?')[0]
        .split('/')
        .filter((v) => v.length > 0);

    // Don't show on Home page, Case Study pages, or Blog/Use Case detail pages
    if (
        pathSegments.length === 0 ||
        router.asPath.includes('/case-study-') ||
        pathSegments[0] === 'case-study' ||
        (pathSegments[0] === 'blog' && pathSegments.length > 1) ||
        (pathSegments[0] === 'use-cases' && pathSegments.length > 1) ||
        (pathSegments[0] === 'news' && pathSegments.length > 1)
    )
        return null;

    const breadcrumbs = pathSegments?.map((segment, index) => {
        const href = `/${pathSegments.slice(0, index + 1).join('/')}`;
        const label = segment.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        return {label, href};
    });

    return (
        <div className="breadcrumb-wrapper">
            <Container>
                <div className={`breadcrumb-inner ${styles.inner}`}>
                    <Link href="/" prefetch={false} passHref className={styles.link}>
                        Home
                    </Link>
                    {breadcrumbs?.map((crumb, index) => (
                        <React.Fragment key={crumb.href}>
                            <Icon name="KeyboardArrowRight" fontSize="inherit" className={styles.separator} />
                            {index === breadcrumbs.length - 1 ? (
                                <p className={styles.current}>{crumb.label}</p>
                            ) : (
                                <Link href={crumb.href} passHref className={styles.link}>
                                    {crumb.label}
                                </Link>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </Container>
        </div>
    );
};

export default Breadcrumbs;
